import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol viewBox=\"0 0 29 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkmark\">\n<path d=\"M12.6177 17.6401L7.57766 12.6001L6.59766 13.5801L12.6177 19.6001L23.1177 9.10012L22.1377 8.12012L12.6177 17.6401Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol